import ListCardMeta from './ListCardMeta';
import PageNav from './PageNav';
import { controlWithWidth } from '@/shared/ui/formClasses';

const DEFAULT_PAGE_SIZES = [10, 25, 50, 100];

type ListPaginationProps = {
  title: string;
  pageSizeLabel: string;
  headingLevel?: 2 | 3 | 4;
  page: number;
  pageSize: number;
  total: number;
  maxPage: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  pageSizes?: number[];
};

/**
 * Il piede di una lista paginata sul server: pagina e risultati, righe per pagina, frecce e
 * numeri di pagina. `pageSizes` quando il backend ha un tetto più basso di 100.
 */
export default function ListPagination({
  title,
  pageSizeLabel,
  headingLevel,
  page,
  pageSize,
  total,
  maxPage,
  onPageChange,
  onPageSizeChange,
  pageSizes = DEFAULT_PAGE_SIZES,
}: ListPaginationProps) {
  const start = (page - 1) * pageSize;
  return (
    <ListCardMeta
      title={title}
      headingLevel={headingLevel}
      currentPage={page}
      maxPage={maxPage}
      total={total}
      pageStart={total === 0 ? 0 : start + 1}
      pageEnd={Math.min(start + pageSize, total)}
      trailing={
        <span className="flex items-center gap-2 text-caption text-subtle">
          <select
            aria-label={pageSizeLabel}
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            className={controlWithWidth('w-20')}
          >
            {pageSizes.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          <span aria-hidden>per pagina</span>
        </span>
      }
      pagination={
        maxPage > 1 ? (
          <PageNav label={title} page={page} maxPage={maxPage} onPageChange={onPageChange} />
        ) : null
      }
    />
  );
}
